module.exports = __webpack_public_path__ + "static/metaImage-085240ce2a12ccb4b31b40cd397d0df7.png";